import React from "react";
import { List, Sheet } from "lucide-react";
import styles from './DocumentProcessor.module.css';

export default function InputModeSwitcher({ inputMode, setInputMode, catalogAppearance = false }) {
    return (
        <div className={styles.inlineButtons}>
            <button
                type="button"
                className={`${styles.btn} ${inputMode === "text" ? styles.btnBlue : ""
                    }`}
                onClick={() => setInputMode("text")}
            >
                {catalogAppearance && <List size={23} aria-hidden="true" />}
                Текст
            </button>

            <button
                type="button"
                className={`${styles.btn} ${inputMode === "excel" ? styles.btnBlue : ""
                    }`}
                onClick={() => setInputMode("excel")}
            >
                {catalogAppearance && <Sheet size={23} aria-hidden="true" />}
                Excel файл
            </button>
        </div>
    );
}
